<mat-drawer-container class="example-container">
  <mat-drawer [ngClass]="isLogin ? 'show' : 'hide'" mode="side" [disableClose]="false" [opened]="sideBarOpen">
    <app-sidenav></app-sidenav>
  </mat-drawer>
  <mat-drawer-content [ngClass]="isLogin ? 'shows' : 'hides'">
    <app-header *ngIf="isLogin" (toggleSidebarForMe)="sideBarToggler()"></app-header>
    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>
